import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './ui/tokens.css'; // New design system's tokens — src/ui/* reads only these
import './skin/skin'; // optional «مشكاة» skin — removable, see src/skin/README.md
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './ui/cache';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Caches the built JS/CSS/fonts so the app shell opens with no internet
// and unchanged files are not re-downloaded on every visit. It no-ops
// outside a production build on purpose — a service worker and the CRA
// dev server share the localhost origin, and letting one cache the
// other's assets poisons the dev environment (see registerServiceWorker).
registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
